var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"wrapper"},[_c('div',{staticClass:"toast"},[_c('div',{staticClass:"content"},[_vm._v("\n            "+_vm._s(_vm.message)+"\n        ")]),_c('div',{staticClass:"footer",on:{"click":_vm.ok}},[_vm._v("\n            知道了\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }